export default {
  PAYMENT_COD: 1,
  PAYMENT_MOMO: 2,
  PAYMENT_IN_APP_PURCHASE: 3,
  PAYMENT_VIETTEL_PAY: 4,
  PAYMENT_VIVIET_PAY: 5,
  PAYMENT_VTC_PAY: 9,
}



// WEBPACK FOOTER //
// ./src/communicate/PaymentMethod.js